<template>
  <div style="font-size:14px;">
    <p style="margin-bottom:10px !important;">封面和简介</p>
    <div style="display:flex;">
      <div v-if="thisCoverSrc === ''" @click="intoEditCover" class="coverBtn">
        <p style="font-size:25px;text-align:center;line-height:100px;color:#1976D2;" class="iconfontFamily">&#xe60b;</p>
      </div>
      <div v-if="thisCoverSrc !== ''" style="position:relative;width:100px;height:100px;">
        <v-img :src="thisCoverSrc" width="100" height="100" alt="加载中"></v-img>
        <div style="position:absolute;top:2px;right:2px;width:16px;height:16px;background:rgba(0, 0, 0, 0.5);border-radius:50%;text-align:center;">
          <v-icon @click="clearCoverSrc" size="10" color="#ffffff" style="margin-top:-5px;margin-left:1px;">
            mdi-close
          </v-icon>
        </div>

      </div>

      <v-textarea v-model="thisIntroduction" height="100" placeholder="请输入内容简介" no-resize outlined hide-details
                  class="introductionTextarea" style="margin-left:5px;font-size:14px;">
        <template v-slot:append>
          <p :style="{'color':thisIntroduction.length > introductionNum ? '#ff5252' : '#a6a6a6'}">{{thisIntroduction.length}}/{{introductionNum}}</p>
        </template>
      </v-textarea>

    </div>

    <edit-create-cover-dialog v-if="editCreateCoverDialogShow" :dialogShow="editCreateCoverDialogShow" @hideCreateCoverDialog="hideCreateCoverDialog" @editCoverOK="editCoverOK"></edit-create-cover-dialog>

  </div>

</template>

<script>
import EditCreateCoverDialog from '/src/components/create_cover/EditCreateCoverDialog';
export default {
  name: "CreateCoverAndIntroduction",
  components: {
    EditCreateCoverDialog
  },
  props:{
    introductionNum:{default:40},
    introduction:{default:""},
    coverSrc:{default:""},
  },
  data(){
    return{
      thisIntroduction:"",

      thisCoverSrc:"",

      //编辑封面弹窗
      editCreateCoverDialogShow:false,

    }
  },
  watch:{
    introduction(){
      this.thisIntroduction = this.introduction;
    },
    thisIntroduction(){
      this.$emit("changeIntroduction",this.thisIntroduction)
    },
    coverSrc(){
      this.thisCoverSrc = this.coverSrc;
    }
  },
  methods:{
    //进入编辑封面
    intoEditCover(){
      this.editCreateCoverDialogShow = true;
    },

    //获得封面
    editCoverOK(param){
      this.thisCoverSrc = param;
      // this.thisCoverSrc = param.replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/","/huaweicloud");  //展示格式
      this.$emit("editCoverOK",param)   //传参正常https路径
    },
    //清除封面
    clearCoverSrc(){
      this.thisCoverSrc = "";
      this.$emit("editCoverOK","")
    },
    //隐藏编辑封面弹窗
    hideCreateCoverDialog(){
      this.editCreateCoverDialogShow = false;
    }



  },
  mounted(){
    this.thisCoverSrc = this.coverSrc;
    this.thisIntroduction = this.introduction;
  }
}
</script>

<style scoped>
.coverBtn{
  width:100px;
  height:100px;
  border:1px #a6a6a6 dashed;
  border-radius:2px;
  cursor:pointer;
}
.coverBtn:hover{
  border-color:#808080;
}


</style>

<style>
/*简介textarea样式*/
.introductionTextarea .v-text-field__slot textarea::-webkit-scrollbar{
  width:0;
}
.introductionTextarea .v-input__slot{
  flex-direction: column;
  padding-right:12px;
}
.introductionTextarea .v-text-field__slot{
  height:calc(100% - 25px);
}
.introductionTextarea .v-input__append-inner{
  margin-top: 5px;
  margin-bottom: 5px;
}
.introductionTextarea textarea{
  line-height:1.15;
}
</style>
